const _temp0 = require("./Lehti_englanniksi.jpg");
const _temp1 = require("./Lehti_ruotsiksi.jpg");
const _temp2 = require("./Spraymaali.jpg");
const _temp3 = require("./Spraymaali_englanniksi.jpg");
const _temp4 = require("./Spraymaali_ruottiks.jpg");
const _temp5 = require("./energiajuoma.jpg");
const _temp6 = require("./energiajuoma_englanniksi.jpg");
const _temp7 = require("./energiajuoma_ruottiks.jpg");
const _temp8 = require("./jakoavain_englanniksi.jpg");
const _temp9 = require("./jakoavain_ruottiks.jpg");
const _temp10 = require("./jalkapallo.jpg");
const _temp11 = require("./jalkapallo_englanniksi.jpg");
const _temp12 = require("./jalkapallo_ruottiks.jpg");
const _temp13 = require("./kanisteri.jpg");
const _temp14 = require("./kanisteri_englanniksi.jpg");
const _temp15 = require("./kanisteri_ruottiks.jpg");
const _temp16 = require("./kirja.jpg");
const _temp17 = require("./kirja_englanniksi.jpg");
const _temp18 = require("./kirja_ruottiks.jpg");
const _temp19 = require("./lapio.jpg");
const _temp20 = require("./lapio_englanniksi.jpg");
const _temp21 = require("./lapio_ruottiks.jpg");
const _temp22 = require("./lehti.jpg");
const _temp23 = require("./lehti_ruottiks.jpg");
const _temp24 = require("./wrench.jpg");
module.exports = {
  "Lehti_englanniksi": _temp0,
  "Lehti_ruotsiksi": _temp1,
  "Spraymaali": _temp2,
  "Spraymaali_englanniksi": _temp3,
  "Spraymaali_ruottiks": _temp4,
  "energiajuoma": _temp5,
  "energiajuoma_englanniksi": _temp6,
  "energiajuoma_ruottiks": _temp7,
  "jakoavain_englanniksi": _temp8,
  "jakoavain_ruottiks": _temp9,
  "jalkapallo": _temp10,
  "jalkapallo_englanniksi": _temp11,
  "jalkapallo_ruottiks": _temp12,
  "kanisteri": _temp13,
  "kanisteri_englanniksi": _temp14,
  "kanisteri_ruottiks": _temp15,
  "kirja": _temp16,
  "kirja_englanniksi": _temp17,
  "kirja_ruottiks": _temp18,
  "lapio": _temp19,
  "lapio_englanniksi": _temp20,
  "lapio_ruottiks": _temp21,
  "lehti": _temp22,
  "lehti_ruottiks": _temp23,
  "wrench": _temp24
}